import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

/** The one muted loading spinner, named for what is loading. */
export function Spinner({ label, className }: { label: string; className?: string }) {
  return (
    <Loader2
      aria-label={label}
      className={cn("h-4 w-4 text-muted-foreground motion-safe:animate-spin", className)}
    />
  );
}
